export const APP_VERSION = process.env.VUE_APP_VERSION_NAME || "";
export const isSG =
  APP_VERSION.startsWith("SG") ||
  APP_VERSION.startsWith("NOSG") ||
  APP_VERSION.startsWith("POSG");
export const isNOSG = APP_VERSION.startsWith("NOSG");
export const isPOSG = APP_VERSION.startsWith("POSG");
